import { render, staticRenderFns } from "./courseReview.vue?vue&type=template&id=4216e6bc"
import script from "./courseReview.vue?vue&type=script&lang=ts"
export * from "./courseReview.vue?vue&type=script&lang=ts"
import style0 from "./courseReview.vue?vue&type=style&index=0&id=4216e6bc&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports